/** Pixels from a CSS length such as `34px`. Missing or invalid values are 0. */
export function readCssPixel(value: string): number {
    const parsed = Number.parseFloat(value);
    if (!Number.isFinite(parsed) || parsed < 0) {
        return 0;
    }
    return parsed;
}
